import { useEffect, useRef, useState } from 'react';
import { Button, Modal, Space } from 'antd';
import { useAuth } from '../../contexts/AuthContext';
import { announcementRequest } from '../../services/announcements.service';
import { AnnouncementBody } from './AnnouncementFields';
export default function AnnouncementPopup() {
  const { user, activeOrganization, loading } = useAuth();
  const [items, setItems] = useState([]); const [index, setIndex] = useState(0); const [open, setOpen] = useState(false);
  const shown = useRef(new Set());
  const userId = user?.id;
  useEffect(() => {
    if (loading || !userId) return undefined;
    let active = true; setItems([]); setOpen(false); setIndex(0); shown.current.clear();
    const load = async () => {
      try { const result = await announcementRequest('post', '/me/announcements/popup'); if (active && result.length) { setItems(result); setIndex(0); setOpen(true); } } catch { /* Disabled feature or unavailable network: keep login usable. */ }
    };
    // Debounce StrictMode remount so it cannot consume an invisible reservation.
    const timer = setTimeout(load, 250);
    return () => { active = false; clearTimeout(timer); };
  }, [userId, activeOrganization?.id, loading]);
  useEffect(() => {
    const item = items[index]; if (!open || !item || shown.current.has(item.id)) return;
    const timer = setTimeout(async () => {
      try { await announcementRequest('post', `/me/announcements/${item.id}/popup-shown`, { token: item.token }); shown.current.add(item.id); }
      catch { /* An unacknowledged display remains eligible on a later entry. */ }
    }, 100);
    return () => clearTimeout(timer);
  }, [items, index, open]);
  return <Modal open={open} title="اطلاعیه" onCancel={() => setOpen(false)} footer={<Space><Button onClick={() => setOpen(false)}>بستن</Button><span>{index + 1} از {items.length}</span>{index > 0 && <Button onClick={() => setIndex(index - 1)}>قبلی</Button>}{index < items.length - 1 && <Button type="primary" onClick={() => setIndex(index + 1)}>بعدی</Button>}</Space>}>{items[index] && <AnnouncementBody item={items[index]} />}</Modal>;
}
